// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'futuraPTProBoldOblique', 'futuraPTProBoldOblique Fallback'"},"className":"__className_9cf9cb","variable":"__variable_9cf9cb"};